import axios from '../index'

const getContactInfo = query => {
    return axios.get(`contact-us${query}`)
}

export default {getContactInfo}